import * as React from "react";
import { Box, Button } from "@mui/material";
import PropTypes from "prop-types";

//Assets
import { Link } from "react-router-dom";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useTheme } from "@mui/styles";
import { useTranslation } from "react-i18next";

import { SHOPIFY_URL } from "../../utils/shopify.utils";
import CartButton from "../Buttons/CartButton";
import ContainedButton from "../Buttons/ContainedButton";
import logo from "../../assets/images/Logo.svg";

const Header = ({ showBuildMyBed, showCart, cartIconColor, styles = {} }) => {
  const theme = useTheme();
  let navigate = useNavigate();
  const { t } = useTranslation();
  return (
    <header
      style={{
        // background: `rebeccapurple`,
        // marginBottom: "1.45rem",
        height: "10vh",
      }}
    >
      <div
        className="row"
        style={{
          margin: "0 auto",
          padding: "1rem",
        }}
      >
        <Box className="col-8" sx={{ display: "inline-flex" }}>
          <button
            variant="text"
            onClick={() => {
              return (window.top.location.href = SHOPIFY_URL);
            }}
            style={{ borderColor: "transparent", float: "left" }}
          >
            <img style={{ marginBottom: 0 }} src={logo}></img>
          </button>
          {/*
            color: #0f475d;
            font-family: Century Gothic,sans-serif;
            font-weight: 400;
            font-style: normal;
            font-size: 16px;
            text-transform: none;
            position: relative;
            text-decoration: none;
            */}

          <div style={{
            marginTop: "1.5rem",
            paddingLeft: "4rem",
            textAlign: "center",
            width: "100%"
          }}><a
            style={{
              color: "#0f475d",
              fontFamily: "Century Gothic,sans-serif",
              fontWeight: "400",
              fontStyle: "normal",
              fontSize: "16px",
              textTransform: "none",
              position: "relative",
              textDecoration: "none",
            }} href="tel:18553872339" className="phone">
            <i style={{ color: "#b1d34a", paddingRight: "0.5rem" }} className="fa-solid fa-phone"></i>1-855-387-2339</a>

            <a style={{
              color: "#0f475d",
              fontFamily: "Century Gothic,sans-serif",
              fontWeight: "400",
              fontStyle: "normal",
              fontSize: "16px",
              textTransform: "none",
              position: "relative",
              textDecoration: "none",
            }} href="mailto:Service@evrbed.com" className="email">
              <i style={{ color: "#b1d34a", paddingRight: "0.5rem", paddingLeft: "1rem" }} className="fa-solid fa-envelope"></i>Service@evrbed.com</a></div>
        </Box>
        <div className="col-4">
          <div className="row flex align-items-center justify-content-end">
            {showBuildMyBed && (
              <ContainedButton
                className="col-auto"
                onClick={() =>
                  (window.top.location.href =
                    SHOPIFY_URL + "pages/evrbase")
                }
              >
                {t("BUILD MY BED")}
              </ContainedButton>
            )}
            {showCart && (
              <CartButton
                cartIconColor={cartIconColor}
                className="col-auto cart-button"
              ></CartButton>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

Header.propTypes = {
  siteTitle: PropTypes.string,
};

Header.defaultProps = {
  siteTitle: "",
};

export default Header;
